import React from 'react'

const JoyrideBeaconHidden = (props, ref) => (
  <div style={{ display: 'none' }} ref={ref} />
)

export default React.forwardRef(JoyrideBeaconHidden)
